import { useState, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';

import BancoInterActions from './BancoInterActions';

function GatewayActions({ values, onPerformCompanyPaymentGatewayAction }) {
  const [isLoading, setIsLoading] = useState(false);

  const [actionOutput, setActionOutput] = useState(null);

  const handlePerformAction = useCallback(
    (action, values) => {
      setIsLoading(true);

      const errorCallback = () => {
        setIsLoading(false);
      };

      onPerformCompanyPaymentGatewayAction(
        values.id,
        action,
        {},
        output => {
          setActionOutput(output);
          setIsLoading(false);
        },
        errorCallback,
      );
    },
    [onPerformCompanyPaymentGatewayAction],
  );

  return (
    <>
      <Row>
        <Col>
          <h5>Ações do provedor</h5>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: '10px',
            }}
          >
            {['BANCO_INTER'].includes(values.mnemonic) && (
              <BancoInterActions
                values={values}
                handlePerformAction={handlePerformAction}
              />
            )}
          </div>
        </Col>
      </Row>
      {actionOutput && <pre>{JSON.stringify(actionOutput, null, 2)}</pre>}
    </>
  );
}

export default GatewayActions;
